import React from "react";
import CommunitySpace from "../../components/CommunitySpace";
import PropTypes from "prop-types";

import "../../styles/communitySpace.scss";

const ShoppingPage = ({ isParanoma }) => {
  return <CommunitySpace isParanoma={isParanoma} />;
};

ShoppingPage.propTypes = { isParanoma: PropTypes.bool };

export default ShoppingPage;
